var n = /* @__PURE__ */ ((t) => (t.noResultText = "noResultText", t))(n || {});
const o = {
  [n.noResultText]: "Nebylo nalezeno žádné místo"
}, e = {
  [n.noResultText]: "Ingen placering fundet"
}, c = {
  [n.noResultText]: "Kein Standort gefunden"
}, a = {
  [n.noResultText]: "Kein Standort gefunden"
}, u = {
  [n.noResultText]: "Δεν βρέθηκε τοποθεσία"
}, s = {
  [n.noResultText]: "No location found"
}, i = {
  [n.noResultText]: "No location found"
}, l = {
  [n.noResultText]: "No location found"
}, r = {
  [n.noResultText]: "No location found"
}, p = {
  [n.noResultText]: "No se encontró ninguna ubicación"
}, R = {
  [n.noResultText]: "No se encontró ninguna ubicación"
}, S = {
  [n.noResultText]: "Sijaintia ei löytynyt"
}, T = {
  [n.noResultText]: "Aucun emplacement trouvé"
}, I = {
  [n.noResultText]: "Aucun emplacement trouvé"
}, h = {
  [n.noResultText]: "Aucun emplacement trouvé"
}, x = {
  [n.noResultText]: "Aucun emplacement trouvé"
}, L = {
  [n.noResultText]: "Nem található hely"
}, N = {
  [n.noResultText]: "Nessuna posizione trovata"
}, d = {
  [n.noResultText]: "Geen locatie gevonden"
}, m = {
  [n.noResultText]: "Ingen plassering funnet"
}, g = {
  [n.noResultText]: "Nie znaleziono lokalizacji"
}, E = {
  [n.noResultText]: "Nenhuma localização encontrada"
}, f = {
  [n.noResultText]: "Nu a fost găsită nicio locație"
}, A = {
  [n.noResultText]: "Ingen plats hittades"
}, v = {
  [n.noResultText]: "Konum bulunamadı"
};
export {
  o as SearchInputLocationCS,
  e as SearchInputLocationDA,
  c as SearchInputLocationDE,
  a as SearchInputLocationDEAT,
  u as SearchInputLocationEL,
  s as SearchInputLocationEN,
  i as SearchInputLocationENCA,
  l as SearchInputLocationENGB,
  r as SearchInputLocationENUS,
  p as SearchInputLocationES,
  R as SearchInputLocationESMX,
  S as SearchInputLocationFI,
  T as SearchInputLocationFR,
  I as SearchInputLocationFRBE,
  h as SearchInputLocationFRCA,
  x as SearchInputLocationFRCH,
  L as SearchInputLocationHU,
  N as SearchInputLocationIT,
  d as SearchInputLocationNL,
  m as SearchInputLocationNO,
  g as SearchInputLocationPL,
  E as SearchInputLocationPT,
  f as SearchInputLocationRO,
  A as SearchInputLocationSV,
  v as SearchInputLocationTR
};
